import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-confirmation-modal-tw',
    imports: [CommonModule],
    templateUrl: './confirmation-modal-tw.component.html',
    styleUrl: './confirmation-modal-tw.component.scss'
})
export class ConfirmationModalTWComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() message = '';
  @Input() confirmButtonText = 'Confirm';
  @Input() cancelButtonText = 'Cancel';
  @Input() type: 'approve' | 'reject' = 'approve';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
